import React, { Component } from 'react';
import {
    CCard,
    CCardBody,
    CCardGroup,
    CForm,
    CCol,
    CFormInput,
    CFormLabel,
    CRow
} from '@coreui/react';
import AppButton from 'src/components/AppButton'
import {
    cilSave
} from '@coreui/icons'
import ServerConnector from 'src/ServerConnector'
import PageHeader from 'src/components/PageHeader'

class AddSubjects extends Component {
    constructor(props) {
        super(props);
        this.state = {
            subject_seq: this.props.page_data.subject_seq,
            pageNamePrefix: this.props.page_data.subject_seq == -999 ? "Add" : "Edit",
            inputs: {
                subject_name: "",
                subject_nameerr: "",
                description: "",
                descriptionerr: ""
            }
        };
    }
    componentDidMount() {
        if (this.state.subject_seq != -999) {

            this.props.showPageSpinner(true);

            let connector = new ServerConnector();
            let dataMap = {
                "_action_code": "GET_SUBJECT_DETAILS",
                "subject_seq": this.state.subject_seq

            }
            connector.postData(dataMap, (data) => { // success
                
                this.props.showPageSpinner(false);

                let inputs = this.state.inputs;
                inputs["subject_name"] = data.data[0].subject_name;
                inputs["description"] = data.data[0].description;
                this.setState({
                    inputs: inputs
                })
            }, (err_cd, msg, data) => { // failure
                
                this.props.showPageSpinner(false);

                this.props.showAlert("Error", msg, "Ok", null, () => {
                    this.props.navigate("manage_subjects")
                })
            })
        }
    }
    updateInput(inputName, event) {

        let inputs = this.state.inputs;
        inputs[inputName] = event.target.value;
        inputs[inputName + "err"] = "";
        this.setState({
            inputs: inputs
        });
    }
    validateForm() {
        var isValid = true;
        let inputs = this.state.inputs;

        if (inputs.subject_name.length == 0) {
            inputs["subject_nameerr"] = "Required";
            isValid = false;
        }
        // if (inputs.description.length == 0) {
        // 	inputs["descriptionerr"] = "Required";
        // 	isValid = false;
        // }
        if (!isValid) {
            this.setState({ inputs: inputs });
        }
        else {
            this.props.showConfirmation(
                "Confirmation",
                "Do you want to save this Subject?",
                "Yes",
                "No",
                null,
                () => { this.submit_form() }
            );
        }
    }
    submit_form() {

        this.props.showPageSpinner(true);

        let connector = new ServerConnector();
        var dataMap;
        if (this.state.subject_seq == -999) {
            dataMap = {
                "_action_code": "ADD_SUBJECT",
                "subject_name": this.state.inputs.subject_name,
                "description": this.state.inputs.description

            }
        }
        else {
            dataMap = {
                "_action_code": "UPDATE_SUBJECT",
                "subject_seq": this.state.subject_seq,
                "subject_name": this.state.inputs.subject_name,
                "description": this.state.inputs.description
            }
        }
        connector.postData(dataMap, (data) => { // success

            this.props.showPageSpinner(false);

            this.props.showAlert("Success", data.msg, "Ok", null, () => {
                this.props.navigate("manage_subjects")
            })
        }, (err_cd, msg, data) => { // failure

            this.props.showPageSpinner(false);
            
            if (data.data) {

                let inputs = this.state.inputs;

                for (let key in data.data) {

                    inputs[key + "err"] = data.data[key];
                }

                this.setState({
                    inputs: inputs
                });
                return;
            }
            
            this.props.showAlert("Error", msg, "Ok", null, null)
        })
    }
    render() {
        return (
            <>
                <PageHeader 
                    page_name={this.state.pageNamePrefix + " " + this.props.page_name}
                    onBackPressed={() => this.props.navigate("manage_subjects")} />
                <CCardGroup>
                    <CCard className="p-4">
                        <CCardBody>
                            <CForm className="row g-3">
                                <CCol md={6}>
                                    <CFormLabel htmlFor="subjectName">Subject Name *</CFormLabel>
                                    <CFormInput type="text" id="subjectName" maxLength="64"
                                        onChange={(event) => { this.updateInput("subject_name", event) }}
                                        value={this.state.inputs.subject_name} />
                                    <div className="inputError">
                                        {this.state.inputs.subject_nameerr}
                                    </div>
                                </CCol>
                                <CCol md={6}>
                                    <CFormLabel htmlFor="description">Description</CFormLabel>
                                    <CFormInput type="text" id="description" maxLength="64"
                                        onChange={(event) => { this.updateInput("description", event) }}
                                        value={this.state.inputs.description} />
                                    <div className="inputError">
                                        {this.state.inputs.descriptionerr}
                                    </div>
                                </CCol>
                                <CRow className="mt-4">
                                    <CCol xs={12} className="alignCenter">
                                        <AppButton
                                            size="md"
                                            name="Submit"
                                            color="primary"
                                            icon={cilSave}
                                            isLoading={false}
                                            isBoldFont={false}
                                            onClick={() => this.validateForm()}>
                                            Submit
                                        </AppButton>
                                    </CCol>
                                </CRow>
                            </CForm>
                        </CCardBody>
                    </CCard>
                </CCardGroup>
            </>
        );
    }
}

export default AddSubjects;